// One progressively enhanced row. Links and touch scrolling work without JavaScript.
class CollectionSubcategoryCarousel extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.resize?.disconnect();
    this.mutations?.disconnect();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.observedList = null;
    const update = () => {
      this.list = this.querySelector('.collection-subcategories__list');
      if (!this.list) return;
      if (this.observedList !== this.list) {
        this.resize.disconnect();
        this.resize.observe(this.list);
        this.observedList = this.list;
      }
      const overflow = this.list.scrollWidth > this.list.clientWidth + 2;
      const left = Math.abs(this.list.scrollLeft);
      this.querySelectorAll('[data-direction]').forEach(button => {
        const disabled = button.dataset.direction === 'previous' ? left < 2 : left + this.list.clientWidth >= this.list.scrollWidth - 2;
        if (button.hidden === overflow) button.hidden = !overflow;
        if (button.disabled !== disabled) button.disabled = disabled;
      });
    };
    const move = direction => {
      this.list = this.querySelector('.collection-subcategories__list');
      if (!this.list) return;
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      this.list.scrollBy({left: direction * (rtl ? -1 : 1) * Math.max(1, this.list.clientWidth - 10), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    // Filtering can morph children while retaining this custom element.
    this.addEventListener('click', event => {
      const button = event.target instanceof Element ? event.target.closest('[data-direction]') : null;
      if (button && this.contains(button) && !button.disabled) move(button.dataset.direction === 'previous' ? -1 : 1);
    }, options);
    this.addEventListener('scroll', update, { ...options, passive: true, capture: true });
    this.addEventListener('keydown', event => {
      const list = this.querySelector('.collection-subcategories__list');
      if (event.target !== list || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const rtl = getComputedStyle(list).direction === 'rtl';
      move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
    }, options);
    this.resize = new ResizeObserver(update);
    this.mutations = new MutationObserver(update);
    this.mutations.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    update();
  }
  disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.mutations?.disconnect(); }
}
if (!customElements.get('collection-subcategory-carousel')) customElements.define('collection-subcategory-carousel', CollectionSubcategoryCarousel);
